const minusIconPath = `<path d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/>`;
const plusIconPath = `<path d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/>`;

document.addEventListener("click", function (e) {
  const itemHeader = e.target.closest(".product-description-accordion-header");
  if (!itemHeader) return;
  const accordion = document.getElementById("product-description-accordion");
  if (!accordion || !accordion.contains(itemHeader)) return;
  const item = itemHeader.closest("li");
  if (!item) return;
  const itemContent = item.querySelector(
    ".product-description-accordion-content",
  );
  const headerIcon = itemHeader.querySelector("svg");
  if (!itemContent || !headerIcon) return;

  const isOpen = itemContent.style.display === "block";
  itemContent.style.display = isOpen ? "none" : "block";
  headerIcon.innerHTML = !isOpen ? minusIconPath : plusIconPath;
});
document.addEventListener("click", function (event) {
  const trigger = event.target.closest(".size-guide-modal-trigger--dynamic");
  if (!trigger) return;
  event.preventDefault();
  const fitGuide = document.querySelector("#fit-guide");
  if (!fitGuide) return;
  const fitGuideContent = fitGuide.querySelector(
    ".product-description-accordion-content",
  );
  const fitGuideHeader = fitGuide.querySelector(
    ".product-description-accordion-header",
  );

  itemHeader.onclick = function () {
    const itemContent = item.querySelector(
      ".product-description-accordion-content",
    );
    const headerIcon = itemHeader.querySelector("svg");

    const isOpen = itemContent.style.display === "block";

    itemContent.style.display = isOpen ? "none" : "block";
    headerIcon.innerHTML = !isOpen
      ? `<path d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/>`
      : `<path d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/>`
  };
});

document.addEventListener('click', function (event) {
  if (!event.target.closest('.size-guide-modal-trigger--dynamic')) return;
  event.preventDefault();
  const fitGuide = document.querySelector('#fit-guide');
  if (!fitGuide) return;
  const fitGuideContent = fitGuide.querySelector('.product-description-accordion-content');
  const fitGuideHeader = fitGuide.querySelector('.product-description-accordion-header');
  if (!fitGuideContent || !fitGuideHeader) return;
  const headerIcon = fitGuideHeader.querySelector('svg');

  fitGuide.scrollIntoView({ behavior: 'smooth', block: 'start' });

  if (fitGuideContent.style.display === 'none' || fitGuideContent.style.display === '') {
    fitGuideContent.style.display = 'block';
    if (headerIcon) {
      headerIcon.innerHTML = `<path d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/>`;
    }
  }
});
